export default __webpack_public_path__ + "231002c720578d808ab1334f4f2b6ad5.jpg";